import React from "react";
import { BaseIconProps } from "../../types/styles";

const XIcon = ({
    id,
    className,
    size = 28,
    customColor,
    ...rest
}: BaseIconProps) => {
    const color = customColor ?? "var(--neutral-500)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-x"}
            className={className}
            height={size}
            width={size}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 28 28"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.73919 7.73992C7.3747 8.10441 7.3747 8.69536 7.73919 9.05985L12.6792 13.9999L7.73921 18.9399C7.37472 19.3044 7.37472 19.8954 7.73921 20.2599C8.1037 20.6243 8.69465 20.6243 9.05914 20.2599L13.9992 15.3198L18.9392 20.2599C19.3037 20.6243 19.8946 20.6243 20.2591 20.2599C20.6236 19.8954 20.6236 19.3044 20.2591 18.9399L15.3191 13.9999L20.2591 9.05985C20.6236 8.69536 20.6236 8.10441 20.2591 7.73992C19.8947 7.37543 19.3037 7.37543 18.9392 7.73992L13.9992 12.68L9.05912 7.73992C8.69463 7.37543 8.10368 7.37543 7.73919 7.73992Z"
                fill={color}
            />
        </svg>
    );
};

export default XIcon;
